(() => {
  'use strict';
  const shopRoot = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:document.body.dataset.currency || 'USD'}).format(value / 100);
  const openers = new WeakMap();
  const closeMenus = () => document.querySelectorAll('[data-mega-toggle]').forEach(button => {
    button.setAttribute('aria-expanded','false');
    const panel = document.getElementById(button.dataset.megaToggle);
    if (panel) panel.hidden = true;
  });
  function openDialog(dialog, opener) {
    if (!dialog || dialog.open) return;
    closeMenus();
    document.querySelectorAll('dialog[open]').forEach(other=>{if(other!==dialog)other.close();});
    if (opener) openers.set(dialog,opener);
    dialog.showModal();
    const input = dialog.querySelector('input[type=search]');
    if (input) input.focus();
  }
  document.addEventListener('close', event => {
    const opener = openers.get(event.target);
    if (opener && opener.isConnected) opener.focus();
  },true);
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const openButton = document.querySelector('[data-mega-toggle][aria-expanded=true]');
      closeMenus();
      if (openButton) openButton.focus();
    }
  });
  let cartPending = false;
  function cartBusy(busy, message='') {
    cartPending=busy;
    const dialog=document.getElementById('cart-drawer');
    if (!dialog) return;
    dialog.setAttribute('aria-busy',String(busy));
    const status=dialog.querySelector('[data-cart-status]');
    if(status)status.textContent=message;
    dialog.querySelectorAll('[data-cart-content] button,[data-cart-content] input').forEach(el=>{el.disabled=busy;});
    dialog.querySelectorAll('[data-cart-remove]').forEach(el=>el.setAttribute('aria-disabled',String(busy)));
  }
  async function loadCartModal(opener) {
    openDialog(document.getElementById('cart-drawer'),opener);
    if(cartPending)return;
    const previousError=document.querySelector('#cart-drawer [data-cart-error]');
    if(previousError)previousError.textContent='';
    cartBusy(true,'Loading your cart…');
    try {await refreshCart();}
    catch(err){const area=document.querySelector('#cart-drawer [data-cart-error]');if(area)area.textContent=err.message;}
    finally{cartBusy(false);}
  }
  async function refreshCart() {
    const responses = await Promise.all([
      fetch(shopRoot+'cart.js',{headers:{Accept:'application/json'},credentials:'same-origin',cache:'no-store'}),
      // Asking /cart for application/json returns cart data, not rendered sections.
      fetch(shopRoot+'cart?section_id=cart-drawer',{headers:{Accept:'text/html'},credentials:'same-origin',cache:'no-store'})
    ]);
    if (responses.some(r=>!r.ok)) throw new Error('The cart could not be refreshed. Please open the cart page.');
    const cart = await responses[0].json();
    const fragment = await responses[1].text();
    const parsed = new DOMParser().parseFromString(fragment, 'text/html');
    const next = parsed.querySelector('[data-cart-content]');
    const current = document.querySelector('#cart-drawer [data-cart-content]');
    if (!next || !current) throw new Error('Cart display could not be refreshed. Please use the cart page.');
    const active=document.activeElement;
    const focusWasInCart=current.contains(active);
    const focusedKey=active?.getAttribute('data-cart-quantity');
    current.innerHTML=next.innerHTML;
    const error=current.querySelector('[data-cart-error]');
    if(error)error.textContent='';
    if(focusWasInCart) {
      const match=[...current.querySelectorAll('[data-cart-quantity]')].find(el=>el.dataset.cartQuantity===focusedKey);
      (match || document.querySelector('#cart-drawer [data-close-dialog]'))?.focus();
    }
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=String(cart.item_count));
    return cart;
  }
  async function updateLine(key, quantity, origin) {
    if(cartPending)return;
    if(!Number.isFinite(quantity)||quantity<0||!Number.isInteger(quantity)){
      const area=document.querySelector('#cart-drawer [data-cart-error]');
      if(area)area.textContent='Please enter a whole quantity of zero or more.';
      return;
    }
    const dialog = origin.closest('dialog');
    const error = (dialog || document).querySelector('[data-cart-error]');
    if (error) error.textContent='';
    cartBusy(true,'Updating your cart…');
    try {
      const response = await fetch(shopRoot+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,quantity)})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'The quantity could not be updated.');
      if (dialog) await refreshCart(); else window.location.reload();
    } catch (err) {
      if (error) error.textContent=err.message;
    } finally {cartBusy(false);}
  }
  document.addEventListener('click', event => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const toggle = target.closest('[data-mega-toggle]');
    if (toggle) {
      const wasOpen = toggle.getAttribute('aria-expanded')==='true';
      closeMenus();
      if (!wasOpen) {
        toggle.setAttribute('aria-expanded','true');
        const panel=document.getElementById(toggle.dataset.megaToggle);
        if (panel) panel.hidden=false;
      }
      return;
    }
    if (!target.closest('[data-header]')) closeMenus();
    const opener=target.closest('[data-open-dialog]');
    if (opener) openDialog(document.getElementById(opener.dataset.openDialog),opener);
    let cartOpener=target.closest('[data-open-cart]');
    const cartLink=target.closest('a[href]');
    if(!cartOpener && cartLink && !cartLink.hasAttribute('data-cart-fallback') && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button===0 && (!cartLink.target || cartLink.target==='_self')) {
      const url=new URL(cartLink.href,location.href);
      if(url.origin===location.origin && url.pathname.replace(/\/$/,'')===(shopRoot+'cart').replace(/\/$/,'') && !url.search && !url.hash)cartOpener=cartLink;
    }
    if(cartOpener){event.preventDefault();loadCartModal(cartOpener);}
    if(cartPending && target.closest('#cart-drawer [data-cart-remove]')){event.preventDefault();return;}
    if (target.closest('[data-close-dialog]')) target.closest('dialog')?.close();
    if (target instanceof HTMLDialogElement) {
      const rect=target.getBoundingClientRect();
      if (event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom) target.close();
    }
    const stepper=target.closest('[data-quantity-step]');
    if (stepper) {
      const input=stepper.closest('.quantity-control').querySelector('input');
      const min=Number(input.min || 0), max=input.max ? Number(input.max) : Infinity;
      input.value=String(Math.min(max,Math.max(min,Number(input.value || 0)+Number(stepper.dataset.quantityStep))));
      input.dispatchEvent(new Event('change',{bubbles:true}));
    }
    const remove=target.closest('[data-cart-remove]');
    if (remove) {event.preventDefault();updateLine(remove.dataset.cartRemove,0,remove);}
    const thumbnail=target.closest('[data-media-select]');
    if (thumbnail) showMedia(thumbnail.closest('[data-product]'),thumbnail.dataset.mediaSelect);
    const railButton=target.closest('[data-rail-target]');
    if (railButton) {
      const rail=document.getElementById(railButton.dataset.railTarget);
      if (rail) rail.scrollBy({left:Number(railButton.dataset.direction)*rail.clientWidth*.9,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
  });
  function showMedia(scope,id) {
    if (!scope) return;
    const media=[...scope.querySelectorAll('[data-media-id]')];
    const chosen=media.find(item=>item.dataset.mediaId===String(id) || item.dataset.imageId===String(id));
    if (!chosen) return;
    media.forEach(item=>{item.hidden=item!==chosen;if(item!==chosen)item.querySelectorAll('video').forEach(v=>v.pause());});
    scope.querySelectorAll('[data-media-select]').forEach(button=>button.setAttribute('aria-current',String(button.dataset.mediaSelect===chosen.dataset.mediaId)));
  }
  document.addEventListener('change',event=>{
    const input=event.target;
    if (!(input instanceof Element)) return;
    if (input.matches('[data-cart-quantity]')) {
      updateLine(input.dataset.cartQuantity,Number(input.value),input);
      return;
    }
    if (!input.matches('[data-variant-option]')) return;
    const scope=input.closest('[data-product]');
    const data=scope.querySelector('[data-product-json]');
    if (!data) return;
    const product=JSON.parse(data.textContent);
    const options=[...scope.querySelectorAll('[data-variant-option]')].map(select=>select.value);
    const variant=product.variants.find(v=>v.options.every((option,index)=>option===options[index]));
    const id=scope.querySelector('input[name=id]');
    const add=scope.querySelector('[data-add-button]');
    const status=scope.querySelector('[data-stock-status]');
    id.value=variant ? variant.id : '';
    add.disabled=!variant || !variant.available;
    add.textContent=!variant?'Unavailable':variant.available?'Add to cart':'Sold out';
    if (status) status.textContent=!variant?'This combination is not available.':variant.available?'Available to order':'Currently unavailable';
    if (variant) {
      scope.querySelector('[data-product-price]').textContent=money(variant.price);
      const compare=scope.querySelector('[data-product-compare]');
      compare.hidden=!(variant.compare_at_price>variant.price);
      compare.textContent=variant.compare_at_price>variant.price?money(variant.compare_at_price):'';
      if (variant.featured_media) showMedia(scope,variant.featured_media.id); else if (variant.featured_image) showMedia(scope,variant.featured_image.id);
      const url=new URL(window.location.href);
      url.searchParams.set('variant',variant.id);
      history.replaceState({},'',url);
    }
  });
  document.addEventListener('submit',async event=>{
    const form=event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-product-form]')) return;
    event.preventDefault();
    const button=event.submitter || form.querySelector('[type=submit]');
    const error=form.querySelector('[data-product-error]') || form.parentElement.querySelector('[data-product-error]');
    if (error) error.textContent='';
    if (button) button.disabled=true;
    try {
      const response=await fetch(shopRoot+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      const data=await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added.');
      await loadCartModal(button);
    } catch(err) {
      if (error) error.textContent=err.message;
    } finally {
      if (button) button.disabled=false;
    }
  });
  let searchTimer,searchAbort;
  document.addEventListener('input',event=>{
    const input=event.target;
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-predictive-search]')) return;
    clearTimeout(searchTimer);
    if (searchAbort) searchAbort.abort();
    const dialog=input.closest('dialog'),list=dialog.querySelector('[data-search-results]'),status=dialog.querySelector('[data-search-status]');
    list.replaceChildren();status.textContent='';
    const query=input.value.trim();
    if (query.length<2) return;
    searchTimer=setTimeout(async()=>{
      searchAbort=new AbortController();
      try {
        const response=await fetch(shopRoot+'search/suggest.json?q='+encodeURIComponent(query)+'&resources[type]=product&resources[limit]=6',{signal:searchAbort.signal});
        if (!response.ok) throw new Error('Search suggestions are unavailable.');
        const data=await response.json();
        if (input.value.trim()!==query) return;
        const products=data.resources?.results?.products || [];
        products.forEach(product=>{
          const li=document.createElement('li'),a=document.createElement('a'),title=document.createElement('span');
          a.href=product.url;title.textContent=product.title;
          const source=typeof product.image==='string'?product.image:product.image?.url;
          if (source) {const img=document.createElement('img');img.src=source;img.alt='';img.width=65;img.height=65;a.append(img);}
          a.append(title);li.append(a);list.append(li);
        });
        status.textContent=products.length?products.length+' product suggestions':'No products found. Try another search or view all results.';
      } catch(err) {
        if (err.name!=='AbortError') status.textContent='Use Search to view the full results.';
      }
    },250);
  });
  function initCarousels(scope=document) {
    scope.querySelectorAll('[data-carousel]').forEach(carousel=>{
      if (carousel.dataset.initialized) return;
      carousel.dataset.initialized='true';
      const slides=[...carousel.querySelectorAll('[data-slide]')],dots=[...carousel.querySelectorAll('[data-slide-index]')],play=carousel.querySelector('[data-carousel-play]');
      let index=0,paused=matchMedia('(prefers-reduced-motion:reduce)').matches,startX=0;
      function activate(next) {
        index=(next+slides.length)%slides.length;
        slides.forEach((slide,i)=>{slide.hidden=i!==index;});
        dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===index)));
      }
      function label() {if(play){play.textContent=paused?'▶':'Ⅱ';play.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');}}
      dots.forEach(dot=>dot.addEventListener('click',()=>{activate(Number(dot.dataset.slideIndex));paused=true;label();}));
      if(play)play.addEventListener('click',()=>{paused=!paused;label();});
      carousel.addEventListener('touchstart',event=>{startX=event.changedTouches[0].clientX;},{passive:true});
      carousel.addEventListener('touchend',event=>{const delta=event.changedTouches[0].clientX-startX;if(Math.abs(delta)>55){activate(index+(delta<0?1:-1));paused=true;label();}},{passive:true});
      carousel._timer=setInterval(()=>{if(!paused&&!document.hidden&&!carousel.matches(':focus-within'))activate(index+1);},7500);
      activate(0);label();
    });
  }
  initCarousels();
  document.addEventListener('shopify:section:load',event=>initCarousels(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-carousel]').forEach(c=>clearInterval(c._timer)));
  const desktop=matchMedia('(min-width:768px)');
  const setupFilters=()=>document.querySelectorAll('.filter-toggle').forEach(details=>details.open=desktop.matches);
  setupFilters();desktop.addEventListener('change',setupFilters);
})();
